import { add, sub } from 'date-fns';
export function getVirtualRange(hoveredDate, startDate, endDate) {
    let start = null;
    let end = null;
    if (startDate) {
        if (Number(hoveredDate) < Number(sub(startDate, { days: 1 }))) {
            start = hoveredDate;
            end = sub(startDate, { days: 1 });
        }
        else {
            if (!endDate) {
                if (Number(hoveredDate) > Number(add(startDate, { days: 1 }))) {
                    start = add(startDate, { days: 1 });
                    end = hoveredDate;
                }
            }
            else {
                if (Number(hoveredDate) > Number(add(endDate, { days: 1 }))) {
                    start = add(endDate, { days: 1 });
                    end = hoveredDate;
                }
            }
        }
    }
    if (!start || !end)
        return [];
    return [start, end];
}
